export default {
  // Page titles
  'luckySpin.ticket.title': 'Configuración de Boleto de Giro',
  'luckySpin.ticket.management': 'Gestión de Boletos',

  // Form fields
  'luckySpin.ticket.ticketId': 'ID de Boleto',
  'luckySpin.ticket.ticketName': 'Nombre de Boleto',
  'luckySpin.ticket.ticketDescription': 'Descripción',
  'luckySpin.ticket.activityName': 'Actividad Vinculada',
  'luckySpin.ticket.selectActivity': 'Seleccionar Actividad',
  'luckySpin.ticket.validityType': 'Tipo de Validez',
  'luckySpin.ticket.validitySetting': 'Configuración de Validez',
  'luckySpin.ticket.validityHours': 'Horas Válidas Después de Recibir',
  'luckySpin.ticket.validTimeRange': 'Rango de Tiempo Válido',
  'luckySpin.ticket.sort': 'Orden de Clasificación',
  'luckySpin.ticket.status': 'Estado',
  'luckySpin.ticket.remark': 'Observación',
  'luckySpin.ticket.createTime': 'Hora de Creación',
  'luckySpin.ticket.createUser': 'Creador',
  'luckySpin.ticket.updateTime': 'Hora de Actualización',
  'luckySpin.ticket.updateUser': 'Actualizador',

  // Validity types
  'luckySpin.ticket.validity.permanent': 'Permanente',
  'luckySpin.ticket.validity.afterReceive': 'Tiempo Especificado Después de Recibir',
  'luckySpin.ticket.validity.fixedTime': 'Período de Tiempo Fijo',

  // Status
  'luckySpin.ticket.status.enabled': 'Habilitado',
  'luckySpin.ticket.status.disabled': 'Deshabilitado',

  // Buttons
  'luckySpin.ticket.button.add': 'Agregar Boleto',
  'luckySpin.ticket.button.edit': 'Editar',
  'luckySpin.ticket.button.delete': 'Eliminar',
  'luckySpin.ticket.button.detail': 'Detalle',
  'luckySpin.ticket.button.search': 'Buscar',
  'luckySpin.ticket.button.reset': 'Restablecer',

  // Messages
  'luckySpin.ticket.tip.bindRule': 'Cada boleto solo puede estar vinculado a una actividad, y una actividad puede asociarse con múltiples boletos.',
  'luckySpin.ticket.confirm.delete': '¿Está seguro de que desea eliminar este boleto? Esta acción no se puede deshacer.',
  'luckySpin.ticket.message.createSuccess': 'Creado exitosamente',
  'luckySpin.ticket.message.updateSuccess': 'Actualizado exitosamente',
  'luckySpin.ticket.message.deleteSuccess': 'Eliminado exitosamente',
  'luckySpin.ticket.message.operationFailed': 'Operación fallida',
  'luckySpin.ticket.message.cannotDeleteWithUnusedTickets': 'No se puede eliminar: hay boletos de miembros no utilizados',

  // Form validation
  'luckySpin.ticket.validate.ticketNameRequired': 'Por favor ingrese nombre de boleto',
  'luckySpin.ticket.validate.ticketNameMax': 'El nombre del boleto no puede exceder 100 caracteres',
  'luckySpin.ticket.validate.activityRequired': 'Por favor seleccionar una actividad',
  'luckySpin.ticket.validate.validityTypeRequired': 'Por favor seleccionar tipo de validez',
  'luckySpin.ticket.validate.validityHoursRequired': 'Por favor ingrese horas válidas',
  'luckySpin.ticket.validate.validityHoursRange': 'Rango de horas válidas: 1-720',
  'luckySpin.ticket.validate.validTimeRangeRequired': 'Por favor seleccionar rango de tiempo válido',
  'luckySpin.ticket.validate.statusRequired': 'Por favor seleccionar estado',
  'luckySpin.ticket.requiredVipLevel': 'Requisito de Nivel VIP ≥',
  'luckySpin.ticket.validate.requiredVipLevel': 'Por favor seleccionar requisito de nivel VIP (opcional)',

  // Usage Restriction
  'luckySpin.ticket.usageRestrictionType': 'Tipo de Restricción de Uso',
  'luckySpin.ticket.restrictionAmount': 'Cantidad de Restricción',
  'luckySpin.ticket.usageRestriction.none': 'Sin Restricción',
  'luckySpin.ticket.usageRestriction.singleDeposit': 'Cantidad de Depósito Único',
  'luckySpin.ticket.usageRestriction.cumulativeDeposit': 'Cantidad de Depósito Acumulativo',
  'luckySpin.ticket.usageRestriction.bettingTurnover': 'Volumen de Apuestas',
  'luckySpin.ticket.usageRestriction.bettingTurnoverTip': 'Calculado desde la hora de recepción del boleto',
  'luckySpin.ticket.validate.restrictionAmountRequired': 'Por favor ingrese cantidad de restricción',
  'luckySpin.ticket.validate.restrictionAmountMin': 'La cantidad debe ser mayor que 0',
  'luckySpin.ticket.placeholder.usageRestrictionType': 'Seleccionar tipo de restricción de uso',
  'luckySpin.ticket.placeholder.restrictionAmount': 'Ingrese cantidad',

  // Placeholders
  'luckySpin.ticket.placeholder.ticketName': 'Ingrese nombre de boleto',
  'luckySpin.ticket.placeholder.ticketDescription': 'Ingrese descripción',
  'luckySpin.ticket.placeholder.selectActivity': 'Seleccionar actividad',
  'luckySpin.ticket.placeholder.validityType': 'Seleccionar tipo de validez',
  'luckySpin.ticket.placeholder.validityHours': 'Ingrese horas',
  'luckySpin.ticket.placeholder.startTime': 'Hora de inicio',
  'luckySpin.ticket.placeholder.endTime': 'Hora de fin',
  'luckySpin.ticket.placeholder.sort': 'Ingrese orden de clasificación, predeterminado 0',
  'luckySpin.ticket.placeholder.status': 'Seleccionar estado',
  'luckySpin.ticket.placeholder.remark': 'Ingrese observación',

  // Modal titles
  'luckySpin.ticket.modal.addTitle': 'Agregar Boleto',
  'luckySpin.ticket.modal.editTitle': 'Editar Boleto',
  'luckySpin.ticket.modal.detailTitle': 'Detalle de Boleto',

  // Full Page Form
  'luckySpin.ticket.form.title.add': 'Agregar Boleto de Giro',
  'luckySpin.ticket.form.title.edit': 'Editar Boleto de Giro',
  'luckySpin.ticket.form.basicSettings': 'Configuración Básica',
  'luckySpin.ticket.form.multiLanguageSettings': 'Configuración Multiidioma (Pantalla Externa)',
  'luckySpin.ticket.form.ticketNameInternal': 'Nombre de Boleto (Interno)',
  'luckySpin.ticket.form.ticketNameExternal': 'Nombre de Boleto (Pantalla Externa)',
  'luckySpin.ticket.form.ticketDescriptionInternal': 'Descripción de Boleto',
  'luckySpin.ticket.form.ticketDescriptionExternal': 'Descripción de Boleto (Pantalla Externa)',
  'luckySpin.ticket.form.bindActivity': 'Vincular Actividad',
  'luckySpin.ticket.form.selectActivity': 'Por favor seleccionar actividad de giro de suerte',
  'luckySpin.ticket.form.language': 'Idioma',
  'luckySpin.ticket.form.selectLanguage': 'Por favor seleccionar idioma',
  'luckySpin.ticket.form.save': 'Guardar',
  'luckySpin.ticket.form.back': 'Atrás',
  'luckySpin.ticket.form.saving': 'Guardando...',

  // Lucky Spin Activity Template
  'luckySpin.template.title': 'Configuración de Rueda',
  'luckySpin.template.prizeConfig': 'Configuración de Premio',
  'luckySpin.template.commonParams': 'Parámetros Comunes',

  // Prize Types
  'luckySpin.template.prizeType': 'Tipo de Premio',
  'luckySpin.template.prizeType.cash': 'Efectivo',
  'luckySpin.template.prizeType.point': 'Puntos',
  'luckySpin.template.prizeType.physical': 'Premio Físico',
  'luckySpin.template.prizeType.retry': 'Intentar de Nuevo',
  'luckySpin.template.prizeType.noPrize': 'Sin Premio',

  // Prize Fields
  'luckySpin.template.coinCode': 'Moneda',
  'luckySpin.template.cashAmount': 'Cantidad',
  'luckySpin.template.flowMultiple': 'Múltiple de Apuesta',
  'luckySpin.template.pointAmount': 'Cantidad de Puntos',
  'luckySpin.template.prizeTitle': 'Título de Premio (Interno)',
  'luckySpin.template.prizeConfigButton': 'Configurar Multiidioma',
  'luckySpin.template.prizeConfigured': '✓ Configurado',
  'luckySpin.template.prizeLimit': 'Límite',
  'luckySpin.template.probability': 'Probabilidad (%)',
  'luckySpin.template.operation': 'Acción',

  // Common Parameters
  'luckySpin.template.visibleEntry': 'Entrada Visible',
  'luckySpin.template.ticketOnlyVisible': 'Solo visible para usuarios con boletos',
  'luckySpin.template.appOnly': 'Solo Aplicación',
  'luckySpin.template.drawLimit': 'Límite de Sorteo',
  'luckySpin.template.requirePhoneVerified': 'Solo los usuarios verificados pueden sortear',
  'luckySpin.template.cooldownSeconds': 'Enfriamiento (segundos)',

  // Messages
  'luckySpin.template.prizesCountHint': 'La rueda tiene 8 premios fijos (8 sectores)',
  'luckySpin.template.totalProbability': 'Probabilidad Total',
  'luckySpin.template.probabilityError': 'El total actual es {value}%, debe ser 100%',
  'luckySpin.template.rules': 'Reglas',
  'luckySpin.template.rule0': 'La rueda tiene 8 premios fijos',
  'luckySpin.template.rule1': 'La probabilidad soporta 4 decimales',
  'luckySpin.template.rule2': 'La probabilidad total debe = 100%',
  'luckySpin.template.rule3': 'Límite = -1 significa ilimitado',
  'luckySpin.template.rule4': 'Se requiere al menos un premio',

  // Validation
  'luckySpin.template.validate.prizeType': 'Por favor seleccionar tipo de premio',
  'luckySpin.template.validate.coinCode': 'Por favor seleccionar moneda',
  'luckySpin.template.validate.cashAmount': 'Por favor ingrese cantidad',
  'luckySpin.template.validate.cashAmountNegative': 'La cantidad no puede ser negativa',
  'luckySpin.template.validate.flowMultiple': 'Por favor ingrese múltiple de apuesta',
  'luckySpin.template.validate.flowMultipleMin': 'El múltiple de apuesta debe ser ≥ 1',
  'luckySpin.template.validate.pointAmount': 'Por favor ingrese cantidad de puntos',
  'luckySpin.template.validate.pointAmountNegative': 'Los puntos no pueden ser negativos',
  'luckySpin.template.validate.pointAmountInteger': 'Los puntos deben ser número entero',
  'luckySpin.template.validate.prizeTitle': 'Por favor ingrese título de premio',
  'luckySpin.template.validate.prizeTitleMax': 'Máximo 100 caracteres',
  'luckySpin.template.validate.prizeLimit': 'Por favor ingrese límite',
  'luckySpin.template.validate.probability': 'Por favor ingrese probabilidad',
  'luckySpin.template.validate.probabilityRange': 'Rango de probabilidad: 0-100',
  'luckySpin.template.validate.cooldownSeconds': 'Por favor ingrese tiempo de enfriamiento',
  'luckySpin.template.validate.cooldownSecondsNegative': 'El enfriamiento no puede ser negativo',
  'luckySpin.template.validate.probabilitySum': 'La probabilidad total debe ser 100%',
  'luckySpin.template.validate.prizesCount': 'La rueda debe tener exactamente 8 premios',

  // Physical Prize Multi-language
  'luckySpin.template.physical.modalTitle': 'Configurar Multiidioma de Premio',
  'luckySpin.template.physical.prizeTitle': 'Título de Premio',
  'luckySpin.template.physical.prizeImage': 'Imagen de Premio',
  'luckySpin.template.physical.langConfigured': '{count} idiomas configurados',
  'luckySpin.template.physical.validate.prizeTitle': 'Por favor ingrese título de premio',
  'luckySpin.template.physical.validate.prizeImage': 'Por favor cargue imagen de premio',
  'luckySpin.template.physical.saveSuccess': 'Configuración multiidioma guardada',

  // Cash Prize Multi-language
  'luckySpin.template.cash.modalTitle': 'Configurar Multiidioma de Premio en Efectivo',
  'luckySpin.template.cash.prizeImage': 'Imagen de Premio',
  'luckySpin.template.cash.prizeConfigButton': 'Configurar Imágenes de Premio',
  'luckySpin.template.cash.langConfigured': '{count} idiomas configurados',
  'luckySpin.template.cash.validate.prizeImage': 'Por favor cargue imagen de premio',
  'luckySpin.template.cash.saveSuccess': 'Configuración multiidioma guardada',

  // Points Prize Multi-language
  'luckySpin.template.points.modalTitle': 'Configurar Multiidioma de Premio de Puntos',
  'luckySpin.template.points.prizeImage': 'Imagen de Premio',
  'luckySpin.template.points.prizeConfigButton': 'Configurar Imágenes de Premio',
  'luckySpin.template.points.langConfigured': '{count} idiomas configurados',
  'luckySpin.template.points.validate.prizeImage': 'Por favor cargue imagen de premio',
  'luckySpin.template.points.saveSuccess': 'Configuración multiidioma guardada',

  // Grant Log
  'luckySpin.grantLog.title': 'Registro de Otorgamiento de Boletos',
  'luckySpin.grantLog.ticketName': 'Nombre de Boleto',
  'luckySpin.grantLog.grantSource': 'Fuente de Otorgamiento',
  'luckySpin.grantLog.grantType': 'Detalle de Otorgamiento',
  'luckySpin.grantLog.userName': 'Cuenta de Miembro',
  'luckySpin.grantLog.activityDataPkCode': 'Seleccionar Actividad',
  'luckySpin.grantLog.selectActivity': 'Por favor seleccionar actividad',
  'luckySpin.grantLog.activityName': 'Nombre de Rueda',
  'luckySpin.grantLog.status': 'Estado de Boleto',
  'luckySpin.grantLog.grantTime': 'Hora de Otorgamiento',
  'luckySpin.grantLog.type.label': 'Tipo de Otorgamiento',
  'luckySpin.grantLog.type.placeholder': 'Seleccionar tipo de otorgamiento',
  'luckySpin.grantLog.search': 'Buscar',
  'luckySpin.grantLog.reset': 'Restablecer',
  'luckySpin.grantLog.export': 'Exportar',
  'luckySpin.grantLog.exporting': 'Exportando datos...',
  'luckySpin.grantLog.exportSuccess': 'Exportación exitosa',
  'luckySpin.grantLog.exportFailed': 'Exportación fallida',

  // Grant Source
  'luckySpin.grantLog.source.vipReward': 'Recompensa VIP',
  'luckySpin.grantLog.source.batchGrant': 'Otorgamiento de Lote',
  'luckySpin.grantLog.source.systemReward': 'Recompensa del Sistema',
  'luckySpin.grantLog.source.manual': 'Manual',
  'luckySpin.grantLog.source.pointsMall': 'Centro de Puntos',
  'luckySpin.grantLog.source.spinAgain': 'Girar de Nuevo',
  'luckySpin.grantLog.source.pointExchange': 'Intercambio de Puntos',
  'luckySpin.grantLog.source.actReward': 'Recompensa de Actividad',

  // Grant Type
  'luckySpin.grantLog.type.manual': 'Manual',
  'luckySpin.grantLog.type.vipUpgrade': 'Actualización de VIP',
  'luckySpin.grantLog.type.activityReward': 'Recompensa de Actividad',
  'luckySpin.grantLog.type.system': 'Sistema',

  // Ticket Status
  'luckySpin.grantLog.status.unused': 'Sin Usar',
  'luckySpin.grantLog.status.used': 'Utilizado',
  'luckySpin.grantLog.status.expired': 'Expirado',
  'luckySpin.grantLog.status.cancelled': 'Cancelado',

  // Spin Log
  'luckySpin.spinLog.title': 'Registro de Uso de Giro',
  'luckySpin.spinLog.userName': 'Cuenta de Miembro',
  'luckySpin.spinLog.activityName': 'Nombre de Rueda',
  'luckySpin.spinLog.ticketName': 'Nombre de Boleto',
  'luckySpin.spinLog.spinTime': 'Hora de Giro',
  'luckySpin.spinLog.prizeType': 'Tipo de Premio',
  'luckySpin.spinLog.prizeContent': 'Contenido de Premio',
  'luckySpin.spinLog.grantStatus': 'Estado de Otorgamiento',
  'luckySpin.spinLog.grantTime': 'Hora de Otorgamiento',
  'luckySpin.spinLog.search': 'Buscar',
  'luckySpin.spinLog.reset': 'Restablecer',
  'luckySpin.spinLog.export': 'Exportar',
  'luckySpin.spinLog.exporting': 'Exportando datos...',
  'luckySpin.spinLog.exportSuccess': 'Exportación exitosa',
  'luckySpin.spinLog.exportFailed': 'Exportación fallida',

  // Prize Types
  'luckySpin.spinLog.prize.cash': 'Efectivo',
  'luckySpin.spinLog.prize.points': 'Puntos',
  'luckySpin.spinLog.prize.physical': 'Físico',
  'luckySpin.spinLog.prize.again': 'Girar de Nuevo',
  'luckySpin.spinLog.prize.none': 'Sin Premio',

  // Grant Status
  'luckySpin.spinLog.grant.pending': 'Pendiente',
  'luckySpin.spinLog.grant.success': 'Éxito',
  'luckySpin.spinLog.grant.failed': 'Fallido',
};

